import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#sonstigeeinnahme

	{
        "antragstellerIds": [ String ],
        "betragMonatlich": BigDecimal
    }

*/
export const schemaEuropaceUpdateSonstigeEinnahme = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    betragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateSonstigeEinnahme = z.infer<typeof schemaEuropaceUpdateSonstigeEinnahme>;
